import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciPaginationComponent } from './luci-pagination.component';



@NgModule({
  declarations: [LuciPaginationComponent],
  exports: [LuciPaginationComponent],
  imports: [
    CommonModule
  ]
})
export class LuciPaginationModule { }
